
import { useState } from 'react';

export const useTaskDialogs = () => {
  const [taskLogOpen, setTaskLogOpen] = useState(false);
  const [newTaskDialogOpen, setNewTaskDialogOpen] = useState(false);
  const [templateDialogOpen, setTemplateDialogOpen] = useState(false);
  const [emailLogsOpen, setEmailLogsOpen] = useState(false);
  const [userManagementOpen, setUserManagementOpen] = useState(false);
  const [isClearDialogOpen, setIsClearDialogOpen] = useState(false);
  
  return {
    taskLogOpen,
    setTaskLogOpen,
    newTaskDialogOpen,
    setNewTaskDialogOpen,
    templateDialogOpen,
    setTemplateDialogOpen,
    emailLogsOpen,
    setEmailLogsOpen,
    userManagementOpen,
    setUserManagementOpen,
    isClearDialogOpen,
    setIsClearDialogOpen,
  };
};
